import './index.less';
import { useContext, useEffect, useState } from 'react';
import { ReactComponent as CloseSvg } from './icons/close.svg';
import { ReactComponent as WarningSvg } from './icons/warning.svg';
import { useParams } from 'react-router-dom';
import { getWarnings, updateWarning } from '@/api/monitoring/warning';
import { Warning } from '@/global/interface/monitoring/warning';
import TnMessage from '@/global/components/message';
import { Button, Skeleton, Image, message, Modal } from 'antd';
import dayjs from 'dayjs';
import { WARNING_LEVEL_DICT } from '@/enums/warning-level';
import { SIUnit, Transfer2DisplayScale } from '@/global/utils/unit-type';
import { SystemContext } from '@/App';
import { SystemStatus } from '@/global/store/system-store';
import { getHistoryImageStr, getHistoryVideoUrl } from '@/api/device/sensor';
import { DragModal } from 'tncet-common';
import TnModal from '@/global/components/base-modal';


interface IProps {
    setShowWarning: (value: boolean) => void
}

export default function WarningRightMainPanel(props: IProps) {

    const { projectId } = useParams();
    const [warnings, setWarnings] = useState<Warning[]>([]); // 报警列表
    const [loading, setLoading] = useState<boolean>(false); // loading
    const systemContext = useContext<SystemStatus>(SystemContext);

    const [historyImageVisible, setHistoryImageVisible] = useState<boolean>(false);
    const [historyVideoVisible, setHistoryVideoVisible] = useState<boolean>(false);
    const [base64Img, setBase64Img] = useState<string>(null);
    const [videoUrl, setVideoUrl] = useState<string>(null);

    // 初始化
    useEffect(() => {
        if (!projectId) return;
        setLoading(true);
        generateData();
    }, [projectId])

    useEffect(() => {
        if (!projectId) return;
        generateData();
    }, [systemContext.warningCount])

    const generateData = () => {
        getWarnings(+projectId).then(res => {
            if (res.status === 200) {
                let data: Warning[] = res.data || [];
                setWarnings(data.filter(w => !w.handle));
            }
        }).catch(err => {
            TnMessage.error("获取报警信息失败");
        }).finally(() => {
            setLoading(false);
        })
    }

    const onClickHandle = (warningId: number) => {
        TnModal().baseModal({
            title: "预警处理",
            content: "确认该预警是否已经处理。",
            onOk() {
                updateWarning(warningId, { handle: true }).then(res => {
                    setWarnings([...warnings.filter(w => w.id != warningId)])
                }).catch(e => {
                    message.error("更新失败！")
                }).finally(() => {
                    Modal.destroyAll();
                })
            },
        })

    }

    return (
        <div className='warning-right-panel'>
            <div className='warning-header'>
                报警记录
                <CloseSvg onClick={() => props.setShowWarning(false)} />
            </div>
            <Skeleton loading={loading} active>
                <div className='warning-body'>
                    {warnings?.map((item: Warning, key: number) => (
                        <div className="warning-info" key={key}>
                            <div className="first-row">
                                <WarningSvg />
                                <span>{`${item?.objectName || '-'}的${item?.parameterName || '-'}已超过${WARNING_LEVEL_DICT[item?.warningLevel]}级预警值`}</span>
                            </div>
                            <div className="second-row">
                                <span className='small-text'>{`当前值：`}</span>
                                <span className='large-text'>{`${parseFloat(Number(item?.warningValue * Transfer2DisplayScale(item?.unit)).toFixed(3)) || '-'}`}</span>
                                <span className='small-text' style={{ marginRight: 16 }}>{`${item?.unit || ''}`}</span>
                                <span className='small-text'>{`${WARNING_LEVEL_DICT[item?.warningLevel]}级预警值：`}</span>
                                <span className='large-text'>{`${parseFloat(Number(item?.thresholdValue * Transfer2DisplayScale(item?.unit)).toFixed(3)) || ''}`}</span>
                                <span className='small-text'>{`${item?.unit || ''}`}</span>
                            </div>
                            <div className='third-row'>
                                <div>{dayjs(item?.gmtCreate).format("YYYY-MM-DD HH:mm")}</div>
                                {
                                    (item?.symbol === "invasion_size" || item?.symbol === "deform") &&
                                    <>
                                        <Button onClick={() => {
                                            let time = item.gmtCreate;
                                            if (item.sampleTime) {
                                                time = item.sampleTime;
                                            }
                                            getHistoryImageStr(item.fkId, item.symbol, time).then(res => {
                                                if (res.data && res.data.image) {
                                                    setBase64Img(res.data.image);
                                                    setHistoryImageVisible(true);
                                                }
                                            })
                                        }}>历史图片</Button>
                                        {/* <Button onClick={() => {
                                            let time = item.gmtCreate;
                                            if (item.sampleTime) {
                                                time = item.sampleTime;
                                            }
                                            getHistoryVideoUrl(item.fkId, projectId, time).then(res => {
                                                if (res.data) {
                                                    if (res.data.hasFile && !res.data.url) {
                                                        TnMessage.error("历史视频文件不存在，无法查看");
                                                        return;
                                                    } else if (!res.data.hasFile && !res.data.url) {
                                                        TnMessage.info("后台正在生成视频，请等待约1分钟后再次查看");
                                                        return;
                                                    } else if (res.data.hasFile && res.data.url) {
                                                        setVideoUrl(res.data.url);
                                                        console.log("videoUrl", res.data)
                                                        setHistoryVideoVisible(true);
                                                    }
                                                }
                                            }).catch(err => {
                                                TnMessage.error("获取历史视频失败");
                                            })

                                        }}
                                        >历史视频</Button> */}
                                    </>
                                }
                                <Button onClick={() => { onClickHandle(item.id) }}>处理</Button>
                            </div>
                        </div>
                    ))}
                </div>
            </Skeleton>

            <DragModal
                mask
                centered
                title="历史图片"
                visible={historyImageVisible}
                width={550}
                wrapClassName="img-area-drag-modal"
                onClose={() => setHistoryImageVisible(false)}>
                <div className="img-area-drag-modal-body">

                    <Image
                        src={`data:image/jpeg;base64,${base64Img}`}
                    />
                </div>
            </DragModal>

            <DragModal
                mask
                centered
                title="历史视频"
                visible={historyVideoVisible}
                width={550}
                wrapClassName="img-area-drag-modal"
                onClose={() => setHistoryVideoVisible(false)}>
                <div className="img-area-drag-modal-body">
                    <video
                        controls
                        width="100%"
                        height="100%"
                        style={{ borderRadius: '10px' }}
                    >
                        <source src={videoUrl} type="video/mp4" />
                        Your browser does not support the video.
                    </video>
                </div>
            </DragModal>
        </div>
    )
}